import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {EMPTY, Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {Router} from '@angular/router';
import {ROUTES} from '../../app.routes';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class AuthErrorInterceptor implements HttpInterceptor
{
    private isRedirecting = false;

    constructor(private router: Router, private modalService: NgbModal)
    {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>
    {
        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) =>
            {
                const requestPath = req.url.split('?')[0].split('#')[0];
                const isPublicEndpoint = /(^|\/)public(\/|$)/.test(requestPath);
                if (error.status === 401 && !isPublicEndpoint)
                {
                    if (!this.isRedirecting)
                    {
                        this.isRedirecting = true;
                        sessionStorage.clear();
                        this.modalService.dismissAll();
                        this.router.navigate([ROUTES.PUBLIC.LOGIN.path]).then(() => this.isRedirecting = false);
                    }
                    return EMPTY;
                }
                return throwError(() => error);
            })
        );
    }
}
